import { Typography } from "antd";
import Layout, { Header } from "antd/lib/layout/layout";
import React from "react";
import { useQuery } from "react-query";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { getOMThisInfo } from "../../apis/OrderManagement/order";
import { ReservationListForm } from "../../components/organisms/Reservation";
import { ReservationDetailDrawer } from "../../components/organisms/Reservation/RepairDetail";
import useReservation from "../../hooks/useReservation";
import color from "../../theme/color";

/**
 * @description 마스터계정이 추가되면서 마스터, 일반 계정에 대한 컬럼이 달라짐 (매장명, 매장코드)
 * @description 테이블의 내부 로직은 정상적으로 반응하나, 고정된 구조 상 페이징 속성이 꼬여있음 (pagination { page, pageSize})
 * @description 테이블 페이지 컴포넌트 쪼갤 필요 있음 (230228)
 * @returns
 */
const ReservationManager: React.FC = () => {
  const { reservation, setReservation } = useReservation();

  useQuery(
    ["OM", reservation.repairNo, "OrderThis"],
    () => getOMThisInfo(reservation?.repairNo as string),
    {
      enabled: !!reservation.repairNo,
      refetchOnMount: "always",
      onSuccess: (data) => {
        setReservation({
          ...reservation,
          orderedAt: data.orderedAt,
        });
      },
    }
  );

  return (
    <Layout style={{ height: "calc(100vh - 57px)" }}>
      <Header
        style={{
          padding: "10px 24px",
          display: "flex",
          alignItems: "center",
          borderBottom: `1px solid${color.gray9}`,
          height: 56,
        }}
      >
        <Typography.Title
          color={color.gray2}
          level={3}
          style={{ lineHeight: "30px" }}
        >
          예약현황
        </Typography.Title>
      </Header>
      <PanelGroup
        direction="horizontal"
        style={{ height: "calc(100% - 56px)" }}
      >
        <Panel defaultSize={70} minSize={40} style={{ overflowY: "auto" }}>
          <ReservationListForm />
        </Panel>
        {reservation?.repairNo && (
          <>
            <PanelResizeHandle
              style={{
                height: "100%",
                width: 4,
                background: color.gray12,
                border: `1px solid ${color.gray9}`,
                borderTopWidth: 0,
                borderBottomWidth: 0,
              }}
            />
            <Panel
              defaultSize={30}
              minSize={20}
              maxSize={50}
              style={{
                minWidth: 360,
                position: "relative",
                overflow: "hidden",
              }}
            >
              <div
                id="cgInfoRoot"
                style={{
                  width: "100%",
                  height: "100%",
                  position: "relative",
                }}
              >
                <ReservationDetailDrawer
                  id={reservation.repairNo}
                  onClose={() => {
                    setReservation({ repairNo: undefined });
                  }}
                />
              </div>
            </Panel>
          </>
        )}
      </PanelGroup>
    </Layout>
  );
};
export default ReservationManager;
